import { Context } from 'chartjs-plugin-datalabels';
import { volumeInLabels } from 'PDF/constants/volumeInValues';

import { formatNumber } from 'helpers/numbers';

const volumes = Object.values(volumeInLabels);

// for font-size 26 in charts
export const datasetValueWidth = 13; //14.87;
export const datasetValueHeight = 31.2;

export const chartValueFormatter = (value: string, context: Context, isPercent: boolean = false) => {
  const meta = context.chart.getDatasetMeta(context.datasetIndex);
  const bar = meta.data[context.dataIndex];
  const formattedValue = formatNumber(+value, Number.isInteger(+value) ? 0 : 1) + (isPercent ? '%' : '');
  const finalFormattedValue = formattedValue.includes('-') ? `(${formattedValue.slice(1)})` : formattedValue;
  const valueWidth = datasetValueWidth * finalFormattedValue.length;

  // @ts-expect-error no types
  return valueWidth > bar.width - 5 || datasetValueHeight > bar.height ? '' : finalFormattedValue;
};

export const chartDatalabelFormatter = (value: string, context: Context, isPercent: boolean = false) => {
  const meta = context.chart.getDatasetMeta(context.datasetIndex);
  const bar = meta.data[context.dataIndex];
  const formattedValue = formatNumber(+value, Number.isInteger(+value) ? 0 : 1) + (isPercent ? '%' : '');
  const finalFormattedValue = formattedValue.includes('-') ? `(${formattedValue.slice(1)})` : formattedValue;
  const valueWidth = datasetValueWidth * finalFormattedValue.length;

  // @ts-expect-error no types
  return valueWidth > bar.width - 2 ? '' : finalFormattedValue;
};

export const formatValueWithUnit = (unit: string, value: string) =>
  `${!volumes.includes(unit) ? `${unit}${value}` : `${value} ${unit}`}`;

export const formatUnit = (unit: string) => unit.replace('single', '');
